<template>
  <div v-if="dcfPrepared" class="section-details">
    <div v-if="!haveAllInformations">
      <app-information-msg-component :title="'previsualisation.infoPrev.title'"
                                 :libelleList="getMessagesInfo"
                                 :canClose="false"
      >
      </app-information-msg-component>
    </div>
    <app-infos-generales-prev
      v-else
      :isEditPrevisu="isEditPrevisu"
      :isPrevisualisation="true"
      :isEdit="isEdit"
      :dcf="dcfPrepared"
      :detailDcf="detailDcf"
      :payeurSelected="payeurSelected"
      :afficherLien="afficherLien"
      @masqueRemiseChange="changeMasqueRemise"
      @masqueLigneChange="changeMasqueLigne"
      @changeIsEditPrev="$emit('changeIsEditPrev', $event)"
    />
    <div class="columns"  v-if="dcf.type !== constantes.TYPE_FACTURE ">
      <div class=" column is-10">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('previsualisation.texteEditionSignatureTitle')}}
            </p>
          </header>
          <div class="card-content">
            <b-field :label="$t('previsualisation.texteEditionSignature')">
              <qd-text-editor v-if="isEdit" v-model="dcf.texteEditionSignature"/>
              <span v-else v-html="dcf.texteEditionSignature"></span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import preparationEnvoiBack from '@/services/devisCommandes/preparationEnvoiBack/preparationEnvoiBack';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import AppInfosGeneralesPrev from '@/components/devisCommandeFacture/previsualisation/infosGeneralesPrev';
import updateMasqueLigneWithOrdre from '@/services/devisCommandes/ligneCommande/updateMasqueLigneWithOrdre';
import findLigneWithMasqueLigne from '@/services/devisCommandes/ligneCommande/findLigneWithMasqueLigne';
import { TYPE_FACTURE } from '@/configuration/devisConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'DevisCommandeFacturePrevisualisation',
  props: {
    dcf: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      dcfPrepared: null,
      detailDcf: null,
      payeurSelected: null,
      constantes: {
        TYPE_FACTURE,
      },
    };
  },
  components: {
    AppInformationMsgComponent,
    AppInfosGeneralesPrev,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    haveAllInformations() {
      return !!(this.detailDcf.lignesCommande.length > 0
        && ((this.payeurSelected && this.dcf.type !== TYPE_FACTURE)
          || (this.dcf.type === TYPE_FACTURE && this.detailDcf.destinataireComptable)));
    },
    getMessagesInfo() {
      const messages = [];
      if (this.detailDcf.lignesCommande.length === 0) {
        messages.push({
          isLink: false,
          libelle: this.$i18n.t('previsualisation.infoPrev.ligneCommande'),
        });
      }
      if (!this.payeurSelected && this.dcf.type !== TYPE_FACTURE) {
        messages.push({
          isLink: false,
          libelle: this.$i18n.t('previsualisation.infoPrev.payeur'),
        });
      }
      if (this.dcf.type === TYPE_FACTURE && !this.detailDcf.destinataireComptable) {
        messages.push({
          isLink: false,
          libelle: this.$i18n.t('previsualisation.infoPrev.destinataireComptable'),
        });
      }
      return messages;
    },
    afficherLien() {
      return this.checkIfCurrentSociety(this.dcf.societeId);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    onNewPayeurSelected(index) {
      this.payeurSelected = this.detailDcf.payeurs[index];
      if (this.payeurSelected.repartition === null) this.payeurSelected.repartition = 0;
    },
    changeMasqueRemise(masqueRemise) {
      this.$emit('masqueRemiseChange', masqueRemise);
      this.dcfPrepared.masqueRemise = masqueRemise;
      this.detailDcf.masqueRemise = masqueRemise;
    },
    changeMasqueLigne(ligne) {
      this.$emit('masqueLigneChange', ligne);
      updateMasqueLigneWithOrdre(this.detailDcf.lignesCommande, ligne.ordre, !ligne.masqueLigne);
      if (findLigneWithMasqueLigne(this.detailDcf.lignesCommande)) this.changeMasqueRemise(true);
    },
  },
  destroyed() {
    this.$bus.$off('new-payeur-selected', this.onNewPayeurSelected);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.categorieGroupeProduitDeductible]);
      this.dcfPrepared = preparationEnvoiBack(this.dcf);
      this.dcfPrepared.societeId = this.dcfPrepared.societeId
        ? this.dcfPrepared.societeId : this.societeActiveId;
      const detailDcf = detailDevisCommande(this.dcf);
      detailDcf.lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((ligneEnfant) => {
            ligneEnfant.hover = false;
          });
        }
        if (ligne.ligneCommandeDispositif?.nomenclatureTypeId && typeof ligne.ligneCommandeDispositif.nomenclature === 'string') {
          ligne.ligneCommandeDispositif.nomenclature = JSON.parse(
            ligne.ligneCommandeDispositif.nomenclature,
          );
        }
      });
      this.detailDcf = detailDcf;
      if (this.dcf.type !== TYPE_FACTURE) {
        this.payeurSelected = this.detailDcf.payeurs[0];
      } else {
        this.payeurSelected = {};
      }
      this.$bus.$on('new-payeur-selected', this.onNewPayeurSelected);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
